export const SUP_SECURITY_UPDATES_LOADER = {
  desktop: `
  <div class="cui cui-grid cui-container">
  <div class="cui-skeleton-heading -size--large -spacing--top-80 -spacing--bottom-32">
    <div class="cui-skeleton-heading__content" style="width: 600px;">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>
  <div class="cui-skeleton-paragraph -spacing--bottom-40 -spacing--top-40">
    <div class="cui-skeleton-paragraph__content" style="width: 100%;">
      <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px;"></div>
      <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px;"></div>
    </div>
  </div>
  <div class="-spacing--bottom-64" style="display: flex; gap: 16px">
    <div class="cui-skeleton-button -size--large">
      <div class="cui-skeleton-button__content" style="width: 97px;">
        <div class="cui-skeleton__item cui-skeleton-button__button"></div>
      </div>
    </div>
    <div class="cui-skeleton-button -size--large">
      <div class="cui-skeleton-button__content" style="width: 110px;">
        <div class="cui-skeleton__item cui-skeleton-button__button"></div>
      </div>
    </div>
  </div>
  <div class="cui-skeleton-heading -size--medium -spacing--bottom-32">
    <div class="cui-skeleton-heading__content" style="width: 600px;">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
    </div>
  </div>
  <div style="display: flex; gap: 16px">
    <div class="cui-skeleton-button -size--large">
      <div class="cui-skeleton-button__content" style="width: 126px;">
        <div class="cui-skeleton__item cui-skeleton-button__button"></div>
      </div>
    </div>
    <div class="cui-skeleton-button -size--large">
      <div class="cui-skeleton-button__content" style="width: 117px;">
        <div class="cui-skeleton__item cui-skeleton-button__button"></div>
      </div>
    </div>
  </div>
  <div class="cui-row -spacing--top-16">
    <div class="cui-col-md-4 -spacing--top-16 -spacing--bottom-16">
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 364px;"></div>
      </div>
    </div>
    <div class="cui-col-md-4 -spacing--top-16 -spacing--bottom-16">
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 364px;"></div>
      </div>
    </div>
    <div class="cui-col-md-4 -spacing--top-16 -spacing--bottom-16">
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 364px;"></div>
      </div>
    </div>
    <div class="cui-col-md-4 -spacing--top-16 -spacing--bottom-16">
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 364px;"></div>
      </div>
    </div>
    <div class="cui-col-md-4 -spacing--top-16 -spacing--bottom-16">
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 364px;"></div>
      </div>
    </div>
    <div class="cui-col-md-4 -spacing--top-16 -spacing--bottom-16">
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 364px;"></div>
      </div>
    </div>
  </div>
  <div class="-spacing--bottom-16 -spacing--top-40" style="width: 100%; justify-content: center; display: flex;">
    <div class="cui-skeleton-paragraph -size--small">
      <div class="cui-skeleton-paragraph__content" style="width: 215px;">
        <div class="cui-skeleton__item cui-skeleton__description" style="height: 18px;"></div>
      </div>
    </div>
  </div>
  <div style="width: 100%; justify-content: center; display: flex;">
    <div class="cui-skeleton-rectangle -is--block">
      <div class="cui-skeleton__item" style="width: 215px; height: 40px;"></div>
    </div>
  </div>
</div>
`
};
